import React from 'react';
import { UserContext } from '../../UserContext';
import SiteCommentsForm from './SiteCommentsForm';
import styles from './PhotoComments.module.css';

const SiteComments = (props) => {
  const [comments, setComments] = React.useState(() => props.comments);
  const commentsSection = React.useRef(null);
  const { login } = React.useContext(UserContext);

  React.useEffect(() => {
    commentsSection.current.scrollTop = commentsSection.current.scrollHeight;
    //console.log ('comentariox');
    //console.log(props.comments);
    //props.comments = JSON.parse(props.comments); 
  }, [comments]);

  return (
    <>
      <ul
        ref={commentsSection}
        className={`${styles.comments} ${props.single ? styles.single : ''}`}
      >
        
        {comments && comments.map((comment,index) => (
          <li key={index}>
            <b>{comment.author}: </b>
            <span>{comment.comment}</span>
          </li>
        ))}

      </ul>
      {login && (
        <SiteCommentsForm
          single={props.single}
          id={props.id}
          setComments={setComments}
        />
      )}
    </>
  );
};

export default SiteComments;
